var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4571 18.2071C15.0666 18.5976 14.4334 18.5976 14.0429 18.2071L8.54289 12.7071C8.15237 12.3166 8.15237 11.6834 8.54289 11.2929L14.0429 5.79289C14.4334 5.40237 15.0666 5.40237 15.4571 5.79289C15.8476 6.18342 15.8476 6.81658 15.4571 7.20711L10.6642 12L15.4571 16.7929C15.8476 17.1834 15.8476 17.8166 15.4571 18.2071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChevronLeft);
export default __webpack_public_path__ + "static/media/line-chevron-left.8a6039595e9e3522e074fc7efa212838.svg";
export { ForwardRef as ReactComponent };